import { BaseState } from '@/store/base-state';
import { TableOptions } from '@/types';
import {
  CartHistoryItem, FiltersOrganization, HistroyCartsFilters, UsersFilter,
} from '../../../types';

const default_filters = () => ({
  search: '',
  date: null,
  user_ids: [],
  organization_id: null,
  only_has_unread_changes: false,
  is_external_api: false,
});

export default class CartHistoryState extends BaseState {
  history_carts_list: CartHistoryItem[] = [];

  organizations: FiltersOrganization = {};

  allowed_dates: string[] = [];

  users: UsersFilter[] = [];

  cart_history_loading = false;

  table_options: TableOptions = {
    ...this.create_table_opts,
    sortBy: [''],
    sortDesc: [true],
  };

  filters: HistroyCartsFilters = default_filters();
}
